import React from 'react';
import styled from 'styled-components';
import WaveDivider from './WaveDivider.jsx';

// Styled Components
const AboutSection = styled.section`
  background: white;
  padding: 0 0 100px 0;
  margin: 0 0 0 0;
  position: relative;
  overflow: hidden;
  isolation: isolate;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #333;
  position: relative;
  font-family: var(--font-heading);
  font-weight: 700;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    border-radius: 2px;
  }
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 3rem;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

const AboutImage = styled.div`
  text-align: center;
`;

const ProfilePlaceholder = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 4rem;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }

  i {
    transition: all 0.3s ease;
  }

  &:hover i {
    transform: scale(1.1);
  }
`;

const AboutText = styled.div`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  font-family: var(--font-body);

  p {
    margin-bottom: 1.5rem;
  }

  strong {
    color: #333;
    font-weight: 600;
  }

  em {
    color: #667eea;
    font-style: italic;
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <SectionTitle>Über mich</SectionTitle>
      <AboutContent>
        <AboutImage>
          <ProfilePlaceholder>
            <i className="fas fa-code"></i>
          </ProfilePlaceholder>
        </AboutImage>
        <AboutText>
          <p>
            Software war nie nur Technik für mich – sondern ein Werkzeug, um 
            Probleme elegant zu lösen.
          </p>
          <p>
            Als <strong>Fachinformatikerin mit Auszeichnung</strong> entwickle ich seit 2022 Web‑ und
            Microservice‑Lösungen, automatisiere Deployments und bespreche
            komplexe Anforderungen lieber direkt mit Menschen als mit langen E‑Mails.
          </p>
          <p>
            Ich liebe es, wenn neue Features nahtlos in Produktion gehen, Systeme stabil
            laufen und die Nutzer*innen sagen: <em>„Das ist genau das, was ich brauche."</em>
          </p>
          <p>
            Was jetzt fehlt? Der Blick hinter die Oberfläche. Deshalb will ich den nächsten
            Layer erschließen: <strong>Data Science und Künstliche Intelligenz</strong>. Damit ich nicht
            nur Systeme entwickle, sondern mit datengetriebenen Methoden und KI
            intelligente Lösungen schaffe – effizient, nachvollziehbar und zukunftsfähig.
          </p>
        </AboutText>
      </AboutContent>
      <WaveDivider 
        color="blue" 
        variant="dramatic" 
        animated={true}
        height={120}
      />
    </AboutSection>
  );
};

export default About; 